(function () {
	const EL_NAME = '.image.loading';
	const elements = document.querySelectorAll(EL_NAME);

	if (!elements.length) {
		return;
	}

	init();

	function init() {
		$(EL_NAME).bgLoaded();
	}

})();
